import { Component, Input } from '@angular/core';
import { IConsulta } from 'src/app/pages/consultas/data/consultas';
import { AgendaService } from '../../services/agenda.service';

@Component({
  selector: 'app-detalhes-consulta-modal',
  templateUrl: './detalhes-consulta-modal.component.html',
  styleUrls: ['./detalhes-consulta-modal.component.scss']
})
export class DetalhesConsultaModalComponent {
  @Input() consulta!: IConsulta;

  constructor(private readonly agendaService: AgendaService) {}

  get icon() {
    return `./assets/icons/${this.agendaService.getIconByModality(this.consulta.modality)}_dark.svg`;
  }
}
